<template>
  <v-chip
    :color="color"
    outlined
  >
    {{ timer }}
  </v-chip>
</template>

<script>
import { onMounted, onUnmounted, ref } from '@vue/composition-api'
import getDateDifference from '@/utils/dateDifference'

export default {
  props: {
    dataRegistro: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const timer = ref(getDateDifference(new Date(), new Date(props.dataRegistro)))

    function updateTimer() {
      timer.value = getDateDifference(new Date(), new Date(props.dataRegistro))
    }

    let interval
    onMounted(() => { interval = setInterval(updateTimer, 1000) })
    onUnmounted(() => { clearInterval(interval) })

    return {
      timer,
    }
  },

}
</script>
